<!-- ======================================================================== -->
<!-- HEADER — Navigation par onglets + Toolbar (recherche + tri + créer)  -->
<!-- ======================================================================== -->
<!-- En-tête commun aux deux portées : mêmes filtres et même tri (EP-1120) -->
<div class="drawer-tasks__header">
  <!-- Onglets en tête dans les deux portées, comme les notes -->
  <div class="drawer-tasks__tabs">
    <app-eva-tabs-navigation
      [tabs]="[
        { label: 'À faire', value: 'all', icon: 'pi-list' },
        { label: 'Mes tâches', value: 'mine', icon: 'pi-user' },
        { label: 'Terminées', value: 'done', icon: 'pi-check' },
      ]"
      [activeTab]="activeTab"
      (tabChange)="onTabChange($any($event))"
    ></app-eva-tabs-navigation>
  </div>
  <!-- Filtre sur l'objet de la page : même bandeau que les notes (EP-1120) -->
  @if (isObjectScope) {
    <div class="drawer-tasks__object-filter">
      <span class="drawer-tasks__object-filter-label">
        <i class="pi pi-filter"></i>
        <span class="drawer-tasks__object-filter-name">{{ objectScopeLabel }}</span>
      </span>
      <!-- Seul le retard mérite un compteur : la liste visible donne déjà le total -->
      @if (objectOverdueCount > 0) {
        <span
          class="drawer-tasks__scope-count drawer-tasks__scope-count--alert"
          [evaTooltip]="objectCountTooltip"
          evaTooltipPosition="left"
          >{{ objectOverdueCount }} en retard</span
        >
      }
      <eva-button
        icon="heroXMark"
        variant="text"
        size="small"
        (onClick)="setScope('all')"
        ariaLabel="Retirer le filtre"
      ></eva-button>
    </div>
  }
  @if (!isObjectScope) {
    <!-- Filtres — Chips par type d'objet lié -->
    @if (activeTab !== "done" || hasObjectScope) {
      <div class="drawer-tasks__filter-chips">
        <!-- Retour au filtre sur l'objet de la page -->
        @if (hasObjectScope) {
          <button
            type="button"
            class="drawer-tasks__filter-chip drawer-tasks__filter-chip--context"
            [evaTooltip]="'Revenir aux tâches de ' + objectScopeLabel"
            evaTooltipPosition="bottom"
            (click)="setScope('object')"
          >
            <i class="pi pi-filter"></i>
            {{ objectScopeLabel }}
            @if (objectOverdueCount > 0) {
              <span
                class="drawer-tasks__filter-count drawer-tasks__filter-count--alert"
                [evaTooltip]="objectCountTooltip"
                evaTooltipPosition="bottom"
                >{{ objectOverdueCount }} en retard</span
              >
            }
          </button>
          @if (activeTab !== "done") {
            <span class="drawer-tasks__chips-divider" aria-hidden="true"></span>
          }
        }
        @for (type of activeTab !== "done" ? visibleLinkTypes : []; track type.type) {
          <button
            type="button"
            class="drawer-tasks__filter-chip"
            [class.drawer-tasks__filter-chip--active]="activeFilter === type.type"
            (click)="setFilter(type.type)"
          >
            <i class="pi" [ngClass]="type.icon"></i>
            {{ type.label }}
            @if (type.type !== "ALL") {
              <span class="drawer-tasks__filter-count">{{ type.count }}</span>
            }
          </button>
        }
      </div>
    }
  }

  <!-- Second filtre contextuel (chantier, activité) : sa propre ligne, seulement quand une puce l'active -->
  @if (!isObjectScope && activeTab !== "done" && hasSecondFilter) {
    <div class="drawer-tasks__filters-row">
      <eva-select
        variant="filter"
        [options]="secondFilterOptions"
        [value]="activeFilter === 'PROJECT' ? selectedProjectId : selectedActivityValue"
        (valueChange)="onSecondFilterChange($event)"
        [placeholder]="secondFilterPlaceholder"
        [clearable]="true"
        [searchable]="activeFilter === 'PROJECT'"
      ></eva-select>
    </div>
  }

  <!-- Toolbar sur une ligne, comme les notes : Recherche + Collaborateur + Tri + « + Tâche » -->
  <div class="drawer-tasks__toolbar-row">
    <div class="drawer-tasks__search">
      <eva-input
        icon="heroMagnifyingGlass"
        [clearable]="true"
        placeholder="Rechercher une tâche..."
        size="inline"
        [value]="searchTerm"
        (valueChange)="onSearchInput($event)"
      ></eva-input>
    </div>
    @if (showCollaboratorFilter) {
      <div class="drawer-tasks__sort">
        <eva-button
          icon="heroUser"
          variant="text"
          size="small"
          [severity]="showCollaboratorMenu || selectedCollaboratorId ? 'primary' : 'secondary'"
          (onClick)="$event.stopPropagation(); toggleCollaboratorMenu()"
          [evaTooltip]="'Collaborateur : ' + collaboratorLabel"
          evaTooltipPosition="left"
        ></eva-button>
        @if (showCollaboratorMenu) {
          <div class="drawer-tasks__sort-menu drawer-tasks__collaborator-menu" (click)="$event.stopPropagation()">
            <eva-select
              variant="filter"
              [options]="collaboratorOptions"
              [value]="selectedCollaboratorId"
              (valueChange)="onCollaboratorChange($event)"
              placeholder="Tous les collaborateurs"
              [clearable]="true"
              [searchable]="true"
            ></eva-select>
          </div>
        }
      </div>
    }
    <!-- Terminées : toujours de la plus récente à la plus ancienne, pas de tri à choisir -->
    @if (activeTab !== "done") {
      <div class="drawer-tasks__sort">
        <eva-button
          icon="heroArrowsUpDown"
          variant="text"
          size="small"
          [severity]="showSortMenu || sortBy !== 'manual' ? 'primary' : 'secondary'"
          (onClick)="$event.stopPropagation(); toggleSortMenu()"
          [evaTooltip]="'Trier : ' + sortLabel"
          evaTooltipPosition="left"
        ></eva-button>
        @if (showSortMenu) {
          <div class="drawer-tasks__sort-menu">
            <button
              type="button"
              class="drawer-tasks__sort-option"
              [class.drawer-tasks__sort-option--active]="sortBy === 'manual'"
              (click)="setSortBy('manual')"
            >
              <i class="pi pi-bars"></i> Manuel
            </button>
            <button
              type="button"
              class="drawer-tasks__sort-option"
              [class.drawer-tasks__sort-option--active]="sortBy === 'date'"
              (click)="setSortBy('date')"
            >
              <i class="pi pi-calendar"></i> Échéance
            </button>
            <button
              type="button"
              class="drawer-tasks__sort-option"
              [class.drawer-tasks__sort-option--active]="sortBy === 'urgency'"
              (click)="setSortBy('urgency')"
            >
              <i class="pi pi-flag"></i> Urgence
            </button>
            <button
              type="button"
              class="drawer-tasks__sort-option"
              [class.drawer-tasks__sort-option--active]="sortBy === 'title'"
              (click)="setSortBy('title')"
            >
              <i class="pi pi-sort-alpha-down"></i> Titre A→Z
            </button>
          </div>
        }
      </div>
    }
    <!-- Même bouton que « + Note » dans les notes -->
    @if (activeTab !== "done") {
      <eva-button
        icon="heroPlus"
        label="Tâche"
        severity="primary"
        size="small"
        (onClick)="taskListShell?.startCreate()"
      ></eva-button>
    }
  </div>
</div>

@if (isObjectScope) {
  <div class="drawer-tasks__body">
    <!-- Même référence que le shell global (branches exclusives) : refresh() après suppression / mise à jour -->
    <app-task-list-shell
      #taskListShell
      [context]="'object'"
      [objectFilter]="objectShellFilter"
      [objectSections]="activeTab === 'done' ? 'done' : 'active'"
      [showAllLink]="true"
      (showAllRequested)="setScope('all')"
      [compact]="false"
      [enableDragDrop]="true"
      [sortBy]="sortBy"
      [searchQuery]="searchTerm"
      [collaboratorFilter]="collaboratorFilterForShell"
      [showObjectLink]="false"
      [showInlineCreate]="activeTab !== 'done'"
      (taskEditRequested)="onTaskClicked($event)"
      (rawTasksLoaded)="onObjectTasksLoaded($event)"
    />
  </div>
} @else {
  <!-- ======================================================================== -->
  <!-- BODY — Liste de tâches via task-list-shell (« Ajouter une tâche » sous chaque section) -->
  <!-- ======================================================================== -->
  <div class="drawer-tasks__body">
    <app-task-list-shell
      #taskListShell
      [context]="'drawer'"
      [compact]="false"
      [enableDragDrop]="true"
      [showInlineCreate]="activeTab !== 'done'"
      [showObjectLink]="true"
      [viewMode]="shellViewMode"
      [sortBy]="sortBy"
      [searchQuery]="searchTerm"
      [linkTypeFilter]="linkTypeFilterForShell"
      [collaboratorFilter]="collaboratorFilterForShell"
      [projectIdFilter]="projectIdFilterForShell"
      (taskClicked)="onTaskClicked($event)"
      (taskEditRequested)="onTaskClicked($event)"
      (tasksCountChange)="onTasksCountChange($event)"
      (rawTasksLoaded)="onRawTasksLoaded($event)"
    />
  </div>
}

<!-- ======================================================================== -->
<!-- DIALOG DE DÉTAIL — Overlay par-dessus le drawer                     -->
<!-- ======================================================================== -->
@if (selectedTask) {
  <app-task-detail-dialog
    [task]="selectedTask"
    [visible]="showDetailDialog"
    [employees]="employees"
    (visibleChange)="onDialogVisibleChange($event)"
    (taskUpdated)="onTaskUpdated($event)"
    (taskDeleted)="onTaskDeleted($event)"
  ></app-task-detail-dialog>
}
